<template>
  <div>
    <DropdownActions
      :buttonText="dropdownText"
      :class="$style.datePickerContainer"
      :items="dropdownOptions"
    />
  </div>
</template>

<script>
import {
  DropdownActions, Types,
} from '@jumpcloud/ui-components';
import {
  quickPicksMetadata,
  quickPicksOptions,
} from 'client/Insights/ActivityLog/constants/QuickPicksConsts';
import InsightsAccessMixin from 'client/Insights/InsightsAccessMixin';

const { DropdownMenuItem } = Types;

export default {
  name: 'SystemFleetDistributionDatePicker',

  components: {
    DropdownActions,
  },

  mixins: [InsightsAccessMixin],

  props: {
    defaultTimeFrame: {
      type: Object,
      default: quickPicksMetadata[quickPicksOptions.sevenDays],
    },
  },

  data: () => ({
    quickPicksMetadata,
    inputLabel: '',
  }),

  computed: {
    dropdownOptions() {
      return this.getQuickPicks.map(option => DropdownMenuItem({
        click: () => (this.handleQuickPickClick(option)),
        text: option.displayName,
      }));
    },

    dropdownText() {
      return this.inputLabel === '' ? this.defaultTimeFrame.displayName : this.inputLabel.displayName;
    },

    getQuickPicks() {
      if (this.directoryInsightsPremium) {
        return [
          quickPicksMetadata[quickPicksOptions.twentyFourHours],
          quickPicksMetadata[quickPicksOptions.threeDays],
          quickPicksMetadata[quickPicksOptions.sevenDays],
          quickPicksMetadata[quickPicksOptions.fifteenDays],
          quickPicksMetadata[quickPicksOptions.thirtyDays],
          quickPicksMetadata[quickPicksOptions.fortyFiveDays],
          quickPicksMetadata[quickPicksOptions.sixtyDays],
          quickPicksMetadata[quickPicksOptions.ninetyDays],
        ];
      }
      return [
        quickPicksMetadata[quickPicksOptions.twentyFourHours],
        quickPicksMetadata[quickPicksOptions.threeDays],
        quickPicksMetadata[quickPicksOptions.sevenDays],
        quickPicksMetadata[quickPicksOptions.fifteenDays],
      ];
    },
  },

  methods: {
    handleQuickPickClick(quickPick) {
      this.inputLabel = quickPick;

      if (quickPick.referenceValue === 'LAST_24_HOURS') {
        this.$emit('change', 1);
      } else {
        this.$emit('change', parseInt(quickPick.referenceValue.replace(/[^0-9]/g, ''), 0));
      }
    },
  },
};
</script>

<style module scoped>
@value itemTableZIndex from '~css/z-index.css';

.datePickerContainer {
  display: inline-grid;
  min-width: 14rem;
  z-index: itemTableZIndex;
}

</style>
